import { Box, Typography } from "@mui/material";
import React from "react";
import { VendorsTable } from "./vendorsTable";

interface VendorsLayoutProps {
  children?: React.ReactNode;
  disableInnerChilds?: boolean;
}

export const VendorsLayout: React.FC<VendorsLayoutProps> = ({ children }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        alignItems: "center",
        bgcolor: "whitesmoke",
        justifyContent: "flex-start",
        overflow: "hidden",
        minHeight: 0,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px",
          width: "100%",
          maxWidth: { md: "1400px" },
          flexShrink: 0,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Vendors
        </Typography>
        <Box>{children}</Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          width: "100%",
          maxWidth: { md: "1400px" },
          minHeight: 0,
          overflow: "hidden",
          px: { xs: 1, sm: 0 },
          pb: 2,
        }}
      >
        {children}
        <VendorsTable sx={{ width: "100%", flex: 1, minHeight: 0, mb: 0, height: "100%" }} />
      </Box>
    </Box>
  );
};
export default VendorsLayout;
